import { Component, EventEmitter, Input, Output } from '@angular/core';
import { INoteResponse } from 'src/app/shared/models/evaluation';
import { NoteChangeEvent } from '../evaluation-table.component';


@Component({
  selector: 'app-note-cell',
  templateUrl: './note-cell.component.html',
  styleUrls: ['./note-cell.component.less']
})
export class NoteCellComponent {

  @Input() note: INoteResponse | null = null;
  @Input() readonly = false;
  @Output() noteChange = new EventEmitter<NoteChangeEvent>();

  selectValeur(v: number): void {
    if (this.readonly) return;
    // Désélectionner si déjà sélectionné
    if (this.note?.valeur === v) {
      this.noteChange.emit({ valeur: null, nonApplicable: false });
    } else {
      this.noteChange.emit({ valeur: v, nonApplicable: false });
    }
  }

  toggleNA(): void {
    if (this.readonly) return;
    this.noteChange.emit({
      valeur: null,
      nonApplicable: !this.note?.nonApplicable
    });
  }
}